const desktop = window.matchMedia('(min-width: 992px)');
let observer;
// The product link wraps its photo slider. Pagination changes the slide, not the URL.
document.addEventListener('click', event => {
  if (event.target.closest && event.target.closest('.category__list .photo-slider .splide__pagination button')) {
    event.preventDefault();
  }
}, true);
function mountPhotoSlider(photo) {
  if (!photo.isConnected || photo.classList.contains('is-initialized')) return;
  new i.a(photo, {
    mediaQuery: 'min', type: 'loop', perPage: 1, arrows: false,
    classes: { pagination: 'splide__pagination photo-slider__pagination' },
    breakpoints: { 992: { destroy: true } }
  }).mount();
}
function r() {
  const photos = document.querySelectorAll('.photo-slider:not(.is-initialized)');
  if (!('IntersectionObserver' in window) || desktop.matches) {
    if (observer) observer.disconnect();
    photos.forEach(mountPhotoSlider);
    return;
  }
  if (!observer) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          mountPhotoSlider(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });
    // On widening the viewport Splide must apply its desktop breakpoint to every card.
    if (desktop.addEventListener) desktop.addEventListener('change', r);
    else desktop.addListener(r);
  }
  // Filtering and pagination can replace the entire list. Release detached cards.
  observer.disconnect();
  photos.forEach(photo => {
    if (photo.closest('.category__list')) observer.observe(photo);
    else mountPhotoSlider(photo);
  });
}